import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
const MOCKUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/jdVrssbjQjGtppE5kJgSN1/ChatGPT_Image_4_abr_2026,_11_07_59_p.m..png';
const bonuses = [{
  title: 'Recetas premium para cobrar más caro',
  description: null
}, {
  title: 'Plantillas de Instagram listas para vender',
  description: null
}, {
  title: 'Guiones de WhatsApp para cerrar ventas',
  description: null
}, {
  title: 'Guía de fotografía y packaging para vender más',
  description: 'Aprendé cómo hacer que tus focaccias se vean irresistibles con fotos simples desde tu celular y cómo presentarlas para cobrar más caro.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-warmBrown relative overflow-hidden" data-id="element-15">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_right,rgba(212,168,83,1)_0%,transparent_40%)]" data-id="element-16" />
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_bottom_left,rgba(212,168,83,1)_0%,transparent_40%)]" data-id="element-17" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-19">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 text-gold mb-6 border border-gold/30" data-id="element-20">
            <Gift className="w-8 h-8" data-id="element-21" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4" data-id="element-22">
            Si empezás hoy, te llevás{' '}
            <span className="text-gold italic font-normal" data-id="element-23">
              TODO esto GRATIS
            </span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-24">
          {/* Mockup image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative flex items-center justify-center" data-id="element-25">
            <div className="absolute inset-0 bg-gold/10 blur-[50px] rounded-full pointer-events-none" data-id="element-26" />
            <img src={MOCKUP_IMAGE} alt="Pack completo: Ebook en tablet con los 4 bonus" className="relative z-10 w-full object-contain max-h-[500px] drop-shadow-[0_20px_40px_rgba(0,0,0,0.4)] rounded-2xl" data-id="element-27" />
          </motion.div>

          {/* Bonus list */}
          <div className="flex flex-col gap-5 justify-center" data-id="element-28">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-4 bg-charcoal/70 backdrop-blur-sm border border-gold/20 rounded-xl p-5" data-id="element-29">
                <CheckCircle2 className="w-7 h-7 text-gold flex-shrink-0 mt-0.5" data-id="element-30" />
                <div data-id="element-31">
                  <span className="text-lg font-medium text-cream" data-id="element-32">
                    {bonus.title}
                  </span>
                  {bonus.description && <p className="text-sm text-cream-muted/70 mt-1 leading-relaxed" data-id="element-33">
                      {bonus.description}
                    </p>}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}